import React, { useState } from "react";
import imageCompression from "browser-image-compression";
import img from "../Assets/Spinner-3.gif";

function BgcForm() {
  const [isSameAddressChecked, setIsSameAddressChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [step, setStep] = useState(1);

  /* first form field */

  const [name, setName] = useState("");
  const [fname, setFname] = useState("");
  const [mname, setMname] = useState("");
  const [gender, setGender] = useState("");
  const [date, setDate] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [enumber, setEnumber] = useState("");
  const [companyname, setCompanyName] = useState("");
  const [location, setLocation] = useState("");

  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [address3, setAddress3] = useState("");
  const [post, setPost] = useState("");
  const [police, setPolice] = useState("");
  const [district, setDistrict] = useState("");
  const [tehsil, setTehsil] = useState("");
  const [landmark, setLandmark] = useState("");
  const [pincode, setPincode] = useState("");
  const [state, setState] = useState("");

  const [address11, setAddress11] = useState("");
  const [address22, setAddress22] = useState("");
  const [address33, setAddress33] = useState("");
  const [post1, setPost1] = useState("");
  const [police1, setPolice1] = useState("");
  const [district1, setDistrict1] = useState("");
  const [tehsil1, setTehsil1] = useState("");
  const [landmark1, setLandmark1] = useState("");
  const [pincode1, setPincode1] = useState("");
  const [state1, setState1] = useState("");

  /* forth form field */
  const [aadhar_front_side, setAadhar_Front_Side] = useState("");
  const [aadhar_back_side, setAadhar_Back_Side] = useState("");
  const [passport_size_photo, setPassport_Size_Photo] = useState("");

  const [candidate, setCandidateId] = useState("");

  /*Sixth form... */
  const [tenancy_number, setTenancy_Number] = useState("");
  const [house_owner_name, setHouse_Owner_Name] = useState("");
  const [tenancy_address, setTenancy_Address] = useState("");
  const [residing_date, setResiding_date] = useState("");

  const [isOwnHouse, setIsOwnHouse] = useState(false);

//   const initialState = {
//     family_member: "",
//     neighbour1_name: "",
//     neighbour1_mobile_number: "",
//     neighbour1_address: "",
//     neighbour1_remark: "",
//     neighbour2_name: "",
//     neighbour2_mobile_number: "",
//     neighbour2_address: "",
//     neighbour2_remark: "",
//     residing_date: "",
//     residing_remark: "",
//     bike_quantity: "",
//     car_quantity: "",
//     ac_quantity: "",
//     other: "",
//     candidate:"candidate",

//     residencial_house_photos: Array(5).fill({ photo: null, remark: "" }),
//   };
//   const [formData, setFormData] = useState(initialState);

//   const handleChange = (e, index = null, field = null) => {
//     const { name, type, files, value } = e.target;

//     setFormData((prev) => {
//       if (index !== null && field) {
//         const updatedPhotos = [...prev.residencial_house_photos];

//         if (type === "file" && files.length > 0) {
//           updatedPhotos[index] = { ...updatedPhotos[index], [field]: files[0] };
//         } else {
//           updatedPhotos[index] = { ...updatedPhotos[index], [field]: value };
//         }

//         return { ...prev, residencial_house_photos: updatedPhotos };
//       }

//       return { ...prev, [name]: value };
//     });
//   };

//   const handleImageAdd = () => {
//     setFormData((prev) => ({
//       ...prev,
//       residencial_house_photos: [
//         ...prev.residencial_house_photos,
//         { photo: null, remark: "" },
//       ],
//     }));
//   };


//   const handleSubmit = async (e) => {
//     e.preventDefault();
  
//     const form = new FormData();
  
//     for (const key in formData) {
//       if (key !== "residencial_house_photos") {
//         form.append(key, formData[key]);
//       }
//     }
  
//     formData.residencial_house_photos.forEach((item, index) => {
//       if (item.photo) {
//         form.append(`residencial_house_photos_${index}`, item.photo);
//       }
//       form.append(`residencial_house_photos_remark_${index}`, item.remark);
//     });
  
//     try {
//       const response = await fetch("https://your-backend-url.com/submit-form", {
//         method: "POST",
//         body: form,
//       });
  
//       if (response.ok) {
//         alert("Form submitted successfully!");
//       } else {
//         alert("Submission failed!");
//       }
//     } catch (error) {
//       console.error("Error submitting form:", error);
//       alert("An error occurred while submitting the form.");
//     }
//   };
  
  const hideTenancy = () => {
    const selected = document.getElementById("tenancy1").value;
    setIsOwnHouse(selected === "Rented");
  };

  const handleFileChange = async (event, setStateFunction) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const fileType = file.type;

        if (
          fileType === "application/pdf" ||
          fileType === "image/jpeg" ||
          fileType === "image/png" ||
          fileType === "image/jpg"
        ) {
          if (fileType === "application/pdf") {
            setStateFunction(file);
          } else {
            const options = {
              maxSizeMB: 0.2,
              maxWidthOrHeight: 1920,
              useWebWorker: true,
            };

            const compressedFile = await imageCompression(file, options);
            setStateFunction(compressedFile);
          }
        } else {
          console.error(
            "Unsupported file format. Please upload a PDF, JPG, JPEG, or PNG file."
          );
        }
      } catch (error) {
        console.error("Error processing file:", error);
      }
    }
  };

  const billingFunction = () => {
    setIsSameAddressChecked((prevValue) => !prevValue);
    if (isSameAddressChecked) {
      setAddress11("");
      setAddress22("");
      setAddress33("");
      setPost1("");
      setPolice1("");
      setDistrict1("");
      setTehsil1("");
      setLandmark1("");
      setPincode1("");
      setState1("");
    } else {
      setAddress11(address1);
      setAddress22(address2);
      setAddress33(address3);
      setPost1(post);
      setPolice1(police);
      setDistrict1(district);
      setTehsil1(tehsil);
      setLandmark1(landmark);
      setPincode1(pincode);
      setState1(state);
    }
  };

  const steps = ["Personal Details", "Tanancy",];

  const prevStep = () => {
    if (step > 1) setStep(step - 1);
  };

  const nextStep1 = () => {
    if (
      name &&
      fname &&
      mname &&
      gender &&
      date &&
      email &&
      number &&
      enumber &&
      companyname &&
      location &&
      address1 &&
      post &&
      police &&
      district &&
      tehsil &&
      landmark &&
      pincode &&
      state &&
      address11 &&
      post1 &&
      police1 &&
      district1 &&
      tehsil1 &&
      landmark1 &&
      pincode1 &&
      state1 &&
      aadhar_front_side &&
      aadhar_back_side &&
      passport_size_photo
    ) {
      const emailR =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (emailR.test(email)) {
        setStep((prevStep) => prevStep + 1);
      } else {
        alert("Please enter a valid email address");
      }
    } else {
      alert("Please fill out all required fields");
    }
  };

  /*fifth page form.... */
  const nextStep5 = (e) => {
    e.preventDefault();

    const selectedTenancy = document.getElementById("tenancy1").value;
    if (!selectedTenancy) {
      alert("Please choose a tenancy option.");
      return;
    }
    if (selectedTenancy === "Rented") {
      if (
        !house_owner_name ||
        !tenancy_address ||
        !tenancy_number ||
        !residing_date
      ) {
        alert("Please fill out all required fields for rented tenancy.");
        return;
      }
    }
    BgcFormSubmit(e);
  };

  const BgcFormSubmit = async (e) => {
    setIsLoading(true);
    const formData = new FormData();

    formData.append("full_name", name);
    formData.append("fathers_name", fname);
    formData.append("mothers_name", mname);
    formData.append("gender", gender);
    formData.append("dob", date);
    formData.append("email", email);
    formData.append("contact_number", number);
    formData.append("emergency_number", enumber);
    formData.append("name_of_the_client", companyname);
    formData.append("client_location", location);

    formData.append("permanent_village_city", address1);
    formData.append("permanent_village_city2", address2);
    formData.append("permanent_village_city3", address3);
    formData.append("permanent_post_office", post);
    formData.append("permanent_police_station", police);
    formData.append("permanent_district", district);
    formData.append("permanent_tehsil", tehsil);
    formData.append("permanent_landmark", landmark);
    formData.append("permanent_pincode", pincode);
    formData.append("permanent_state", state);

    formData.append("current_village_city", address11);
    formData.append("current_village_city2", address22);
    formData.append("current_village_city3", address33);
    formData.append("current_post_office", post1);
    formData.append("current_police_station", police1);
    formData.append("current_district", district1);
    formData.append("current_tehsil", tehsil1);
    formData.append("current_landmark", landmark1);
    formData.append("current_pincode", pincode1);
    formData.append("current_state", state1);

    formData.append("adhar_frontside", aadhar_front_side);
    formData.append("adhar_backside", aadhar_back_side);
    formData.append("photo", passport_size_photo);
    formData.append("house_owner_name", house_owner_name);
    formData.append("tenancy_contact", tenancy_number);
    formData.append("address", tenancy_address);
    formData.append("residing_date", residing_date);

    try {
      let response = await fetch(
        "https://humhai.in/background-verification/featured-form/",
        {
          method: "POST",
          body: formData,
        }
      );

      let data = await response.json();
      setCandidateId(data.id);

      if (data.status === 200) {
        setIsLoading(false);
        window.location.reload();
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="form-container">
      <div className="form-header">
        {steps.map((heading, index) => (
          <div
            key={index}
            className={`step-title ${
              step === index + 1 ? "active" : "blurred"
            }`}
          >
            {heading}
          </div>
        ))}
      </div>
      <div className="form-content">
        {step === 1 && (
          <div>
            <div className="bg-light p-3 rounded-lg border border-opacity-50 mx-auto p-1">
              <h2 className="text-center font-bold text-3xl mb-3">
                CANDIDATE{" "}
                <span className="text-orange-600">PERSONAL DETAILS</span>
              </h2>
              <hr />
              <div className="row">
                <div className="col-md-4 col-6">
                  <label htmlFor="name_of_applicant" className="form-label">
                    Name of the Applicant
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    name="name_of_applicant"
                    required
                  />
                </div>
                <div className="col-md-4 col-6">
                  <label htmlFor="Input2" className="form-label">
                    Fathers/Husband/Wife Name
                  </label>
                  <input
                    className="inputtype form-control mb-3"
                    list="projects"
                    value={fname}
                    onChange={(e) => setFname(e.target.value)}
                    name="fathers_name"
                    maxLength="100"
                    required
                  />
                </div>
                <div className="col-md-4 col-6">
                  <label htmlFor="Input3" className="form-label">
                    Mother's Name
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={mname}
                    onChange={(e) => setMname(e.target.value)}
                    name="mothers_name"
                    maxLength="100"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 col-6">
                  <label htmlFor="Input4" className="form-label">
                    Applicant Gender
                  </label>{" "}
                  <select
                    className="inputtype form-control mb-3"
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                    name="gender"
                  >
                    <option value="">choose</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="other">other</option>
                  </select>
                </div>

                <div className="col-md-4 input-icons">
                  <label htmlFor="Input5" className="form-label">
                    Date Of Birth
                  </label>

                  <div className="date-container">
                    <input
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                      type="date"
                      className="inputtype form-control mb-3"
                      name="dob"
                    />
                  </div>
                </div>

                <div className="col-md-4 col-6">
                  <label htmlFor="Input6" className="form-label">
                    Email Id
                  </label>{" "}
                  <input
                    type="email"
                    className="inputtype form-control mb-3"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    name="email"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 input-icons">
                  <label htmlFor="Input5" className="form-label">
                    Contact Number
                  </label>

                  <div className="date-container">
                    <input
                      type="number"
                      className="inputtype form-control mb-3"
                      value={number}
                      onChange={(e) => setNumber(e.target.value)}
                      name="contact_number"
                    />
                  </div>
                </div>

                <div className="col-md-4 col-6">
                  <label htmlFor="Input6" className="form-label">
                    Emergency Contact
                  </label>

                  <input
                    type="number"
                    className="inputtype form-control mb-3"
                    value={enumber}
                    onChange={(e) => setEnumber(e.target.value)}
                    name="emergency_contact"
                  />
                </div>

                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    Company Name
                  </label>

                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={companyname}
                    onChange={(e) => setCompanyName(e.target.value)}
                    name="name_of_client"
                    maxLength="100"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    Company Location
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    name="client_location"
                    maxLength="30"
                  />
                </div>

              </div>

              <div className="row">
                <h2>Permanent Address</h2>
                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    Address Line 1
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={address1}
                    onChange={(e) => setAddress1(e.target.value)}
                    name="village_city"
                    maxLength="25"
                  />
                </div>
                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    Address Line 2 (Optional)
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={address2}
                    onChange={(e) => setAddress2(e.target.value)}
                    name="village_city2"
                    maxLength="25"
                  />
                </div>
                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    Address Line 3 (Optional)
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={address3}
                    onChange={(e) => setAddress3(e.target.value)}
                    name="village_city3"
                    maxLength="25"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    Name of Post Office
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={post}
                    onChange={(e) => setPost(e.target.value)}
                    name="post_office"
                    maxLength="100"
                  />
                </div>
                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    Police Station/Thana
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={police}
                    onChange={(e) => setPolice(e.target.value)}
                    name="police_station"
                    maxLength="100"
                  />
                </div>
                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    District
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={district}
                    onChange={(e) => setDistrict(e.target.value)}
                    name="district"
                    maxLength="100"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    Tehsil
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={tehsil}
                    onChange={(e) => setTehsil(e.target.value)}
                    name="tehsil"
                    maxLength="100"
                  />
                </div>
                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    Landmark
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={landmark}
                    onChange={(e) => setLandmark(e.target.value)}
                    name="landmark"
                    maxLength="100"
                  />
                </div>
                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    Pin Code
                  </label>
                  <input
                    type="number"
                    className="inputtype form-control mb-3"
                    value={pincode}
                    onChange={(e) => setPincode(e.target.value)}
                    name="pine_code"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    State
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    name="state"
                    maxLength="20"
                  />
                </div>
              </div>

              <div className="row mb-4 d-flex flex-row">
                <label
                  style={{ width: "190px" }}
                  className="form-label"
                  htmlFor="same"
                >
                  Same as above?
                </label>
                <input
                  style={{ width: "30px" }}
                  type="checkbox"
                  id="same"
                  name="same"
                  onChange={() => billingFunction()}
                />
              </div>

              <div className="row">
                <h2>Current Address</h2>
                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    Address Line 1
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={address11}
                    onChange={(e) => setAddress11(e.target.value)}
                    name="c_village_city"
                    maxLength="25"
                  />
                </div>
                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    Address Line 2 (Optional)
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={address22}
                    onChange={(e) => setAddress22(e.target.value)}
                    name="c_village_city2"
                    maxLength="25"
                  />
                </div>

                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    Address Line 3 (Optional)
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={address33}
                    onChange={(e) => setAddress33(e.target.value)}
                    name="c_village_city3"
                    maxLength="25"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    Name of Post Office
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={post1}
                    onChange={(e) => setPost1(e.target.value)}
                    name="c_post_office"
                    maxLength="100"
                  />
                </div>

                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    Police Station
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={police1}
                    onChange={(e) => setPolice1(e.target.value)}
                    name="c_police_station"
                    maxLength="100"
                  />
                </div>

                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    District
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={district1}
                    onChange={(e) => setDistrict1(e.target.value)}
                    name="c_district"
                    maxLength="100"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    Tehsil
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={tehsil1}
                    onChange={(e) => setTehsil1(e.target.value)}
                    name="c_tehsil"
                    maxLength="100"
                  />
                </div>

                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    Landmark
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={landmark1}
                    onChange={(e) => setLandmark1(e.target.value)}
                    name="c_landmark"
                    maxLength="100"
                  />
                </div>

                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    Pin Code
                  </label>
                  <input
                    type="number"
                    className="inputtype form-control mb-3"
                    value={pincode1}
                    onChange={(e) => setPincode1(e.target.value)}
                    name="c_pine_code"
                    maxLength="100"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 col-6">
                  <label htmlFor="Input7" className="form-label">
                    State
                  </label>
                  <input
                    type="text"
                    className="inputtype form-control mb-3"
                    value={state1}
                    onChange={(e) => setState1(e.target.value)}
                    name="c_state"
                    maxLength="20"
                  />
                </div>
              </div>
              <h5
                className=" text-center"
                style={{ color: "rgb(255, 119, 0)" }}
              >
                * Upload a Fully Clear and Completed Document *
              </h5>
              <div className="row">
                <div className="col-md-4">
                  <label htmlFor="Input8" className="form-label">
                    Aadhar Card FRONT SIDE
                  </label>
                  <input
                    type="file"
                    className="inputtype form-control mb-3"
                    onChange={(e) => handleFileChange(e, setAadhar_Front_Side)}
                    accept=".png, .jpg"
                    name="aadhar_front"
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="Input9" className="form-label">
                    Aadhar Card BACK SIDE
                  </label>
                  <input
                    type="file"
                    className="inputtype form-control mb-3"
                    onChange={(e) => handleFileChange(e, setAadhar_Back_Side)}
                    name="aadhar_back"
                    accept=".png, .jpg"
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="Input9" className="form-label">
                    Passport Size Photo
                  </label>
                  <input
                    type="file"
                    className="inputtype form-control mb-3"
                    onChange={(e) =>
                      handleFileChange(e, setPassport_Size_Photo)
                    }
                    name="passport_photo"
                    accept=".png, .jpg"
                  />
                </div>
              </div>
            </div>
            <div style={{ overflow: "auto" }}>
              <div style={{ float: "right" }}>
                <button
                  type="button"
                  className="tablinks mb-2 ms-2"
                  onClick={nextStep1}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        )}

        {step === 2 && (
          <div>
            <div className="bg-light p-3 rounded-3 p-3 mx-auto border border-opacity-50">
              <div className="text-center font-bold text-3xl mb-3">
                🏠 CANDIDATE
                <span style={{ color: "rgb(255, 119, 0)" }}> TENANCY</span>{" "}
                DETAILS
              </div>
              <hr />
              <div className="row">
                <div className="col-md-4 col-sm-6">
                  <label>Tenancy</label>

                  <select
                    className="form-control mt-3"
                    name="choose_tenancy"
                    id="tenancy1"
                    onChange={() => {
                      hideTenancy();
                      setHouse_Owner_Name("");
                      setTenancy_Address("");
                      setTenancy_Number("");
                      setResiding_date("");
                    }}
                  >
                    <option value="">Choose</option>
                    <option value="Own House">Own House</option>
                    <option value="Rented">Rented</option>
                  </select>
                </div>
              </div>
              {isOwnHouse ? (
                <div>
                  <div className="row">
                    <div className="col-md-6">
                      <label className="form-label">House Owner Name</label>

                      <input
                        type="text"
                        className="inputtype form-control mb-3"
                        value={house_owner_name}
                        onChange={(e) => setHouse_Owner_Name(e.target.value)}
                        name="house_owner_name"
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Address</label>
                      <input
                        type="text"
                        className="inputtype form-control mb-3"
                        value={tenancy_address}
                        onChange={(e) => setTenancy_Address(e.target.value)}
                        name="tenancy_address"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <label className="form-label">Contact Number</label>

                      <input
                        type="number"
                        className="inputtype form-control mb-3"
                        value={tenancy_number}
                        onChange={(e) => setTenancy_Number(e.target.value)}
                        name="tenancy_number"
                      />
                    </div>
                    <div className="col-md-6 input-icons">
                      <label className="form-label">Residing Date</label>

                      <div className="date-container">
                        <input
                          value={residing_date}
                          onChange={(e) => setResiding_date(e.target.value)}
                          name="residing_date"
                          type="date"
                          className="inputtype form-control mb-3"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="row ms-4 mb-4">
                {isLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: "1",
                      flexDirection: "column",
                    }}
                  >
                    {" "}
                    <img src={img} alt="" />
                    <div style={{ color: "#DE3500", marginTop: "10px" }}>
                      Please Wait ......
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div style={{ overflow: "auto" }}>
              <div style={{ float: "right" }}>
                <button
                  type="button"
                  className="tablinks mb-2 ms-2"
                  style={{ backgroundColor: "#BBBBBB" }}
                  onClick={prevStep}
                  disabled={isLoading}
                >
                  Previous
                </button>
                <button
                  className="tablinks mb-2 ms-2"
                  onClick={nextStep5}
                  disabled={isLoading}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        )}

        {/* {step === 3 && (
          <div className="bg-light p-3 rounded-3 p-3 mx-auto border border-opacity-50">
            <div className="text-center font-bold text-3xl mb-3">
              🏠 Residencial
              <span style={{ color: "rgb(255, 119, 0)" }}>
                {" "}
                Verification
              </span>{" "}
              DETAILS
            </div>
            <hr />
            <div className="row">
              <div className="col-md-4">
                <label htmlFor="family_member">How Many Family Members</label>
                <input
                  type="number"
                  className="inputtype form-control mb-3"
                  name="family_member"
                  placeholder="Enter family members"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="neighbour1_name">
                  Neighbour Name
                </label>
                <input
                  className="inputtype form-control mb-3"
                  type="text"
                  name="neighbour1_name"
                  placeholder="Enter Neighbour Name"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="neighbour1_mobile_number">
                  Neighbour 1 Mobile Number
                </label>
                <input
                  className="inputtype form-control mb-3"
                  type="number"
                  name="neighbour1_mobile_number"
                  placeholder="Enter Neighbour 1 Mobile Number"
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <label htmlFor="neighbour1_address">
                  Neighbour 1 Since
                </label>
                <input
                  className="inputtype form-control mb-3"
                  type="text"
                  name="neighbour1_address"
                  placeholder="Enter Neighbour 1 Since"
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="neighbour1_remark">
                  Neighbour 1 Remark
                </label>
                <input
                  className="inputtype form-control mb-3"
                  onChange={handleChange}
                  type="text"
                  name="neighbour1_remark"
                  placeholder="Enter Neighbour 1 Remark"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="neighbour2_name">
                  Neighbour 2 Name
                </label>
                <input
                  className="inputtype form-control mb-3"
                  type="text"
                  name="neighbour2_name"
                  placeholder="Enter Neighbour 2 Name"
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <label htmlFor="neighbour2_mobile_number">
                  Neighbour 2 Mobile Number
                </label>
                <input
                  className="inputtype form-control mb-3"
                  onChange={handleChange}
                  type="number"
                  name="neighbour2_mobile_number"
                  placeholder="Enter Neighbour 2 Mobile Number"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="neighbour2_address">
                  Neighbour 2 Since
                </label>
                <input
                  className="inputtype form-control mb-3"
                  onChange={handleChange}
                  type="text"
                  name="neighbour2_address"
                  placeholder="Enter Neighbour 2 Since"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="neighbour2_remark">
                  Neighbour 2 Remark
                </label>
                <input
                  className="inputtype form-control mb-3"
                  onChange={handleChange}
                  type="text"
                  name="neighbour2_remark"
                  placeholder="Enter Neighbour 2 Remark"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <label htmlFor="residing_date">Residing Date</label>
                <input
                  className="inputtype form-control mb-3"
                  onChange={handleChange}
                  type="date"
                  name="residing_date"
                  placeholder="Enter Residing Date"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="residing_remark">Residing Remark</label>
                <input
                  className="inputtype form-control mb-3"
                  onChange={handleChange}
                  type="text"
                  name="residing_remark"
                  placeholder="Enter Residing Remark"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="bike_quantity">Bike Quantity</label>
                <input
                  className="inputtype form-control mb-3"
                  onChange={handleChange}
                  type="number"
                  name="bike_quantity"
                  placeholder="Enter Bike Quantity"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <label htmlFor="car_quantity">Car Quantity</label>
                <input
                  className="inputtype form-control mb-3"
                  onChange={handleChange}
                  type="number"
                  name="car_quantity"
                  placeholder="Enter Car Quantity"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="ac_quantity">AC Quantity</label>
                <input
                  className="inputtype form-control mb-3"
                  onChange={handleChange}
                  type="number"
                  name="ac_quantity"
                  placeholder="Enter AC Quantity"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="other">Place</label>
                <input
                  className="inputtype form-control mb-3"
                  onChange={handleChange}
                  type="text"
                  name="other"
                  placeholder="Enter Place"
                />
              </div>
            </div>
            <div>
              {formData.residencial_house_photos.map((item, index) => (
                <div className="row" key={index}>
                  <div className="col-md-4">
                    <label>House Photo {index + 1}</label>
                    <input
                      type="file"
                      accept="image/*"
                      capture="environment"
                      className="inputtype form-control mb-3"
                      onChange={(e) => handleFileChange(e, index, "photo")}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>House Photo {index + 1} Remark</label>
                    <input
                      type="text"
                      className="inputtype form-control mb-3"
                      placeholder={`Enter House Photo ${index + 1} Remark`}
                      value={item.remark}
                      onChange={(e) => handleChange(e, index, "remark")}
                    />
                  </div>
                </div>
              ))}

              <div className="button-section">
                <button
                  className="tablinks mb-2 ms-2"
                  style={{ backgroundColor: "#FF7700" }}
                  type="button"
                  onClick={handleImageAdd}
                  disabled={isLoading}
                >
                  Add
                </button>
                <div style={{ overflow: "auto" }}>
                  <div style={{ float: "right" }}>
                    <button
                      type="submit"
                      className="tablinks mb-2 ms-2"
                      onClick={handleSubmit}
                      disabled={isLoading}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
}
export default BgcForm;
